import { render, staticRenderFns } from "./PostsTemplateHandler.vue?vue&type=template&id=07ed0a58&"
import script from "./PostsTemplateHandler.vue?vue&type=script&lang=js&"
export * from "./PostsTemplateHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports